import type { GetServerSideProps, NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { useBestOffersModal } from '@/hooks/useBestOffersModal';
import { Blog } from '@/layouts';
import { Meta } from '@/layouts/Meta';
import { fetchFilteredBlogItems } from '@/services/supabase';
import { Main } from '@/templates/Main';
import type { IBlogItemDTO } from '@/types/blogInterfaces';

interface IBlogItemsProps {
  blogItems: IBlogItemDTO[];
}

export const getServerSideProps: GetServerSideProps = async ({
  query,
  locale,
}) => {
  const params: any = {
    sort: { field: 'publishedAt', order: 'desc' },
    pagination: {
      start: 0,
      limit: 10,
    },
    locale,
  };

  if (query.country) {
    params.filter = {
      field: 'Country',
      operator: '$eq',
      value: query.country,
    };
  }

  const blogItems = await fetchFilteredBlogItems(params);

  return {
    props: {
      blogItems: blogItems.data,
      ...(await serverSideTranslations(locale || 'en', ['common'])),
    },
  };
};

const BlogPage: NextPage<IBlogItemsProps> = ({ blogItems }) => {
  const { t } = useTranslation();
  useBestOffersModal();
  return (
    <Main
      meta={
        <Meta
          title={t('pages.blog.title')}
          description={t('pages.blog.description')}
          keywords={t('pages.blog.keywords')}
        />
      }
      mobileTitle="Blog"
    >
      <Blog blogItems={blogItems} />
    </Main>
  );
};

export default BlogPage;
